import { createSelector } from 'reselect';
import { resourceSelectors } from '../../utils/resourceSelectors';

export const [authenticatorDevicesAllIds, authenticatorDevicesById, allAuthenticatorDevicesSelector] =
  resourceSelectors('authenticatorDevices');
